export enum BankAccountTypeId {
  Check = 1,
  Wire = 2,
  Ach = 3,
  EfsMoneyCode = 4,
  TriumphFuelCard = 5,
  TChek = 6,
  FuelCard = 7,
  CadAch = 8,
  CadCheck = 9,
  SameDayAch = 10,
  DraftAch = 11,
  DraftCadAch = 12,
  IntlWire = 13,
  MxnAch = 14,
  DraftMxnAch = 15,
  EurWire = 16,
  DraftEurWire = 17,
  ReverseWire = 18,
  LoadPay = 19,
}

export enum BankAccountStatusId {
  Active = 1,
  InactivatedByPayor = 2,
  InactivatedByPayee = 3,
  InactivatedByTriumph = 4,
  PendingVerification = 5,
  Rejected = 6,
  InactivatedByFactorMatch = 7,
  PendingFinalReview = 8,
  BankHashMatchingRequest = 9,
  PendingTransfermateApproval = 10,
  InactivatedByTransfermate = 11,
  RejectedByTransfermate = 12,
}

export const bankAccountRejectionTypeIds = {
  authorizedNumberDisconnected: 3,
  factorAccount: 8,
  fraud: 10,
  intermediaryBank: 7,
  noLongerNeeded: 2,
  other: 9,
  personalAccount: 5,
  requestedInError: 6,
  unableToContact: 1,
  wrongNumber: 4,
} as const;

export const bankAccountPendingStatusIds: Partial<Record<BankAccountStatusId, boolean>> = {
  [BankAccountStatusId.PendingVerification]: true,
  [BankAccountStatusId.PendingFinalReview]: true,
};
